import React, { useState, useEffect, useRef, memo } from "react";
import { RetellWebClient } from "retell-client-js-sdk";
import PhoneCallIcon from "../../images/phone-call.png";
import PhoneCallEndIcon from "../../images/phone-call-end.png";

const VoiceAssistant = () => {
  const retellWebClientRef = useRef(null);
  const [callStatus, setCallStatus] = useState("idle");

  useEffect(() => {
    // Initialize Retell client when component mounts
    retellWebClientRef.current = new RetellWebClient();
    const retellWebClient = retellWebClientRef.current;

    // Set up event listeners for call status changes
    retellWebClient.on("call_started", () => {
      console.log("call started");
      setCallStatus("active");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setCallStatus("ended");
    });

    // When agent starts talking for the utterance
    // useful for animation
    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    // When agent is done talking for the utterance
    // useful for animation
    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    // Real time pcm audio bytes being played back, in format of Float32Array
    // only available when emitRawAudioSamples is true
    retellWebClient.on("audio", (audio) => {
      // console.log(audio);
    });

    // Update message such as transcript
    // You can get transcrit with update.transcript
    // Please note that transcript only contains last 5 sentences to avoid the payload being too large
    retellWebClient.on("update", (update) => {
      // console.log(update);
    });

    retellWebClient.on("metadata", (metadata) => {
      // console.log(metadata);
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      setCallStatus("error");
      // Stop the call
      retellWebClient.stopCall();
    });

    return () => {
      // Clean up event listeners when component unmounts
      if (retellWebClientRef.current) {
        retellWebClientRef.current.removeAllListeners();
      }
    };
  }, []);

  const startCall = async () => {
    try {
      setCallStatus("connecting");
      // Fetch a call ID from your backend
      const response = await fetch("/backend/start-retell-call", {
        method: "POST",
      });
      const responseData = await response.json();
      if (!responseData.data) {
        console.error("No data in response");
        return;
      }
      const { access_token } = responseData.data;

      // Start the call using the Retell client
      if (retellWebClientRef.current) {
        await retellWebClientRef.current.startCall({
          accessToken: access_token,
          // sampleRate: 24000, // (Optional) set sample rate of the audio capture and playback
          // // (Optional) device id of the mic.
          // captureDeviceId: "default",
          // // (Optional) device id of the speaker
          // playbackDeviceId:
          //   "0ec1807fd0fe6e51b990660ec4e2ebb78sdfcba51e279815d00c423ce03407ff",
          // // (Optional) Whether to emit "audio" events that contain raw pcm audio bytes represented by Float32Array
          // emitRawAudioSamples: false,
        });
      } else {
        setCallStatus("error");
      }
    } catch (error) {
      console.error("Error starting call:", error);
      setCallStatus("error");
    }
  };

  const endCall = () => {
    if (retellWebClientRef.current) {
      retellWebClientRef.current.stopCall();
    }
  };

  console.log(callStatus);

  return (
    <div
      style={{
        // position: "fixed",
        // zIndex: 99999,
        // right: 100,
        // bottom: 24,
        // padding: 5,
        // backgroundColor: "white",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // borderRadius: 10,
        // boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
      }}
    >
      {callStatus === "idle" ||
      callStatus === "ended" ||
      callStatus === "error" ? (
        <img
          src={PhoneCallIcon}
          alt="Start Call"
          onClick={startCall}
          style={{ width: 46, height: 46, cursor: "pointer" }}
          title="Talk to PatienTrials"
        />
      ) : (
        <img
          src={PhoneCallEndIcon}
          alt="End Call"
          onClick={endCall}
          style={{ width: 46, height: 46, cursor: "pointer" }}
          title="End Call"
        />
      )}
      {callStatus !== "idle" && (
        <p style={{ margin: 5, position: "absolute", bottom: -24 }}>
          {callStatus}
        </p>
      )}
    </div>
  );
};

export default memo(VoiceAssistant);
